import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetServiceTickets Input Action
 */
export class GetServiceTicketsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetServiceTicketsKey`;
    public getCacheObjectType = () => 'GetServiceTickets';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetServiceTicketsData {
    '@odata.context': string;
    value: IServiceTickets[];
}

export interface IServiceTickets {
    Id: string;
    TicketNumber: string;
    AssetId: string;
    CustomerId: string;
    TypeCode: string;
    StatusCode: string;
    Priority: string;
    CreationDate: string;
    Title: string;
    Description: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetServiceTicketsInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetServiceTicketsInput, ctx: Msdyn365.IActionContext): Promise<IGetServiceTicketsData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const response = await Msdyn365.sendRequest<IGetServiceTicketsData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetServiceTickets(language='${ctx.requestContext.locale}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetServiceTicketsData>>action,
    id: 'GetServiceTickets',
    input: createInput
});
